import React from "react";

import * as Components from "../../components";

export interface PromptProps {
    yumSSOId: string
    onYes?: () => any
    onNo?: () => any
}

export const PhaseQuestion: React.FunctionComponent<PromptProps> = (props) => {
    return <Components.LayoutBlock fill>
        <Components.LayoutBlock inline className="yum-sso-self-service-warning">
            <span className="yum-sso-self-service-warning-icon">!</span>
            <span className="yum-sso-self-service-warning-text">This Yum ID "{props.yumSSOId}" is not associated with any user in Tracks</span>
        </Components.LayoutBlock>
        <Components.LayoutBlock className="yum-sso-self-service-message">
            Would you like to associate this Yum ID "{props.yumSSOId}" with a Tracks User?
        </Components.LayoutBlock>
        <Components.LayoutBlock inline className="yum-sso-self-service-buttons">
            <Components.Button onClick={props.onNo}>
                No
            </Components.Button>
            <Components.Button onClick={props.onYes}>
                Yes
            </Components.Button>
        </Components.LayoutBlock>
    </Components.LayoutBlock>
}